import { Injectable } from '@angular/core';

@Injectable()
/**
 * Feature flags
 */
export class FeatureFlags {

  private diningRooms: boolean = false; // dice si mostrar profile de comedor y tab de elegir comida o no.
  private clonColevisa: boolean = false; // quitar en el futuro.
  private clonStartUpv: boolean = false; // quitar en el futuro.
  private clonLaberit: boolean = false; // quitar en el futuro.

  // TODO: poner a TRUE isWorkdayReminderVisible cuando esté implementada la API.
  private isWorkdayReminderVisible: any = false; // dice si mostrar toggle de recordatorio de fichaje en apartado Configuración

  private showLogoPoweredByFuifi: boolean = this.clonColevisa;

  private showCalendarWorkHistorical = true;

  private showIncidences = true; // indica si hay que mostrar módulo de incidencias o no

  private isMiJornadaCovidVisible = true; // dice si mostrar encuesta covid en tab My-office.

  private isvacanciesVisible = true; // dice si mostrar modulo de vacantes.

  private isCvDocxVisible = true; // dice si mostrar descarga de DOCX.

  private isMapRegisterVisible = false; // dice si mostrar Mapa en registro de Jornada

  private isWorkPhonevisible = false; // dice si mostrar teléfono de contacto en perfil de otro user

  set setDiningRooms(diningRooms: boolean) {
    this.diningRooms = diningRooms;
  }

  set setClonColevisa(clonColevisa: boolean) {
    this.clonColevisa = clonColevisa;
  }

  set setClonStartUpv(clonStartUpv: boolean) {
    this.clonStartUpv = clonStartUpv;
  }
  set setClonLaberit(clonLaberit: boolean) {
    this.clonLaberit = clonLaberit;
  }

  get DiningRooms() {
    return this.diningRooms;
  }

  get SoyColevisa() {
    return this.clonColevisa;
  }

  get ClonStartUpv() {
    return this.clonStartUpv;
  }

  get ClonLaberit() {
    return this.clonLaberit;
  }

  get IsWorkdayReminderVisible() {
    return this.isWorkdayReminderVisible;
  }

  get ShowLogoPoweredByFuifi() {
    return this.showLogoPoweredByFuifi;
  }

  public hasOrganizationPage() : boolean {
    return !this.SoyColevisa && !this.ClonStartUpv;
  }

  showCalendarWork() {
    return this.showCalendarWorkHistorical;
  }
  showInc() {
    return this.showIncidences;
  }

  get IsMyJornadaCovidVisible () {
    return this.isMiJornadaCovidVisible;
  }
  get IsVacanciesVisible () {
    return this.isvacanciesVisible;
  }
  get IsCvDocxVisible () {
    return this.isCvDocxVisible;
  }
  get mapRegisterVisible () {
    return this.isMapRegisterVisible;
  }
  get workPhoneVisible () {
    return this.isWorkPhonevisible;
  }
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/services/featureFlags.ts